import { render, staticRenderFns } from "./VacationsNeedMeetingDayLegend.vue?vue&type=template&id=0a61255b&"
import script from "./VacationsNeedMeetingDayLegend.vue?vue&type=script&lang=js&"
export * from "./VacationsNeedMeetingDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports